export default function Divider() {
  return (
    <>
      <svg width="2" height="74" viewBox="0 0 2 74" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line x1="0.697754" y1="0.5" x2="0.697751" y2="73.5" stroke="#FFF4E3" strokeOpacity="0.2" />
      </svg>
    </>
  );
}
